<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Téléchargement CSV">
        <v-form>
          <v-row>
            <v-col>
              <v-select
                v-if="
                  user.roles.indexOf('ROLE_ADMIN') > -1 ||
                    user.roles.indexOf('ROLE_SUAIO') > -1
                "
                v-model="selectCampus"
                label="Campus"
                :items="lstCampus"
                item-value="id"
                item-text="libelle"
                class="mx-5"
              >
              </v-select>

              <v-select
                v-model="selectStructure"
                label="Structure"
                :items="lstStructures"
                item-value="id"
                item-text="libelle"
                class="mx-5"
              >
              </v-select>
              <v-select
                v-model="selectFormation"
                label="Formation"
                :items="lstFormations"
                item-value="id"
                item-text="libelle"
                class="mx-5"
              >
              </v-select>
            </v-col>
          </v-row>

          <br />
          <div class="text-center">
            <v-btn
              :disabled="!filtreUnique"
              class="mx-2 primary"
              @click="telecharger"
              :loading="loading"
            >
              <v-icon left>mdi-export</v-icon>
              Exporter CSV REO
            </v-btn>
          </div>
        </v-form>

        <v-form>
          <v-row>
            <v-col>
              <v-select
                v-if="
                  user.roles.indexOf('ROLE_ADMIN') > -1 ||
                    user.roles.indexOf('ROLE_SUAIO') > -1
                "
                v-model="selectCampusAtelier"
                label="Campus"
                :items="lstCampus"
                item-value="id"
                item-text="libelle"
                class="mx-5"
              >
              </v-select>
            </v-col>
          </v-row>

          <br />
          <div class="text-center">
            <v-btn
              :disabled="!selectCampusAtelier"
              class="mx-2 primary"
              @click="telechargerCsvAtelier"
              :loading="loading"
            >
              <v-icon left>mdi-export</v-icon>
              Exporter CSV Atelier
            </v-btn>
          </div>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import ApiAtelierRepository from "@/repositories/ApiAtelierRepository";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import ApiStructureRepository from "@/repositories/ApiStructureRepository";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import { saveAs } from "file-saver";
import { mapState } from "vuex";

export default {
  name: "formCsv",
  components: { BaseBlock },
  data() {
    return {
      loading: false,
      selectCampus: "",
      lstCampus: [],
      selectStructure: "",
      lstStructures: [],
      selectFormation: "",
      lstFormations: [],
      critere: "",
      choix: "",
      selectCampusAtelier: ""
    };
  },
  methods: {
    async telecharger() {
      this.loading = true;
      try {
        // on récupère le fichier csv
        const response = await ApiCandidatureRepository.getCsvFile(
          this.critere,
          this.choix
        );

        const blob = new Blob([response.data], {
          type: "text/csv;charset=utf-8"
        });

        saveAs(blob, response.fileName);
      } catch (error) {
        this.$toast.error("Impossible de télécharger le fichier");
      } finally {
        this.loading = false;
      }
    },
    async telechargerCsvAtelier() {
      this.loading = true;
      try {
        // on récupère le fichier csv
        const response = await ApiAtelierRepository.getCsvFile(
          "campus",
          this.selectCampusAtelier
        );

        const blob = new Blob([response.data], {
          type: "text/csv;charset=utf-8"
        });

        saveAs(blob, response.fileName);
      } catch (error) {
        this.$toast.error("Impossible de télécharger le fichier");
      } finally {
        this.loading = false;
      }
    },
    async getCampusLst() {
      try {
        const campusLst = await ApiCampusRepository.getCampusLst();
        this.lstCampus = campusLst;
        campusLst.unshift({ id: 0, libelle: "" });
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getStructureLst() {
      try {
        const structureLst = await ApiStructureRepository.getListeStructuresCsv();
        this.lstStructures = structureLst;
        structureLst.unshift({ id: 0, libelle: "" });
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getFormationLst() {
      try {
        const formationLst = await ApiFormationRepository.getFormationsCsv();
        this.lstFormations = formationLst;
        formationLst.unshift({ id: 0, libelle: "" });
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    }
  },
  created() {
    this.getCampusLst();
    this.getStructureLst();
    this.getFormationLst();
  },
  computed: {
    ...mapState(["user"]),
    filtreUnique() {
      return (
        this.selectCampus > 0 ||
        this.selectStructure > 0 ||
        this.selectFormation > 0
      );
    }
  },
  watch: {
    selectCampus() {
      if (this.selectCampus > 0) {
        this.critere = "campus";
        this.choix = this.selectCampus;
        this.selectStructure = "";
        this.selectFormation = "";
      }
    },
    selectStructure() {
      if (this.selectStructure > 0) {
        this.critere = "structure";
        this.choix = this.selectStructure;
        this.selectCampus = "";
        this.selectFormation = "";
      }
    },
    selectFormation() {
      if (this.selectFormation > 0) {
        this.critere = "formation";
        this.choix = this.selectFormation;
        this.selectCampus = "";
        this.selectStructure = "";
      }
    }
  }
};
</script>
